export var ASPENDENTAL_COLOR = {
  primary: {
    '300': '#E5E9EE',
    '500': '#002855',
    '700': '#001C3C'
  },
  secondary: {
    '300': '#E5EDF8',
    '500': '#004BB9',
    '700': '#003582'
  },
  tertiary: {
    '300': '#E5EDF8',
    '500': '#004BB9',
    '700': '#003582'
  },
  neutrals: {
    white: '#FFFFFF',
    '100': '#F2F3F4',
    '300': '#D6D9DA',
    '700': '#A7ADB0',
    '800': '#696E72',
    '900': '#434A4F'
  },
  text: {
    light: '#FFFFFF',
    disabled: '#A7ADB0',
    tertiary: '#696E72',
    secondary: '#434A4F',
    primary: '#002855',
    link: '#004BB9'
  },
  accent01: {
    '300': '#FFF8D1',
    '500': '#FFEC9F',
    '700': '#FFD96A'
  },
  success: {
    '300': '#E0F5E5',
    '500': '#A4E2B4',
    '700': '#027D5E'
  },
  error: {
    '300': '#FEEAEA',
    '500': '#F1BFBF',
    '700': '#CF2A2A'
  },
  warning: {
    '300': '#FFF8D1',
    '500': '#FFEC9F',
    '700': '#FFD96A'
  },
  info: {
    '300': '#E5F2FF',
    '500': '#B9DEFA',
    '700': '#004BB9'
  },
  background: {
    white: '#FFFFFF',
    neutral: '#F2F3F4',
    light: '#E5F2FF',
    dark: '#002855',
    transparent: 'transparent'
  }
};
export var ASPENDENTAL_FONTS = {
  heroLarge: {
    fontFamily: 'TiemposHeadlineRegular',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '64px',
    lineHeight: '80px',
    letterSpacing: '-0.5px',
    '@media (max-width:600px)': {
      fontSize: '41px',
      lineHeight: '52px'
    }
  },
  heroMedium: {
    fontFamily: 'TiemposHeadlineRegular',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '53px',
    lineHeight: '68px',
    letterSpacing: '-0.5px',
    '@media (max-width:600px)': {
      fontSize: '41px',
      lineHeight: '52px'
    }
  },
  h1: {
    fontFamily: 'TiemposHeadlineRegular',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '38px',
    lineHeight: '52px',
    letterSpacing: '0px',
    '@media (max-width:600px)': {
      fontSize: '29px',
      lineHeight: '36px'
    }
  },
  h2: {
    fontFamily: 'TiemposHeadlineRegular',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '31px',
    lineHeight: '44px',
    letterSpacing: '0px',
    '@media (max-width:600px)': {
      fontSize: '25px',
      lineHeight: '32px'
    }
  },
  h3: {
    fontFamily: 'MessinaSansSemiBold',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '26px',
    lineHeight: '36px',
    letterSpacing: '-0.5px',
    '@media (max-width:600px)': {
      fontSize: '22px',
      lineHeight: '28px'
    }
  },
  h4: {
    fontFamily: 'MessinaSansSemiBold',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '22px',
    lineHeight: '32px',
    letterSpacing: '-0.5px',
    '@media (max-width:600px)': {
      fontSize: '20px',
      lineHeight: '28px'
    }
  },
  breadcrumb: {
    fontFamily: 'MessinaSansRegular',
    fontWeight: '300',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0px'
  },
  bodyXLargeBook: {
    fontFamily: 'MessinaSansBook',
    fontStyle: 'normal',
    fontWeight: '350',
    fontSize: '22px',
    lineHeight: '32px',
    letterSpacing: '-0.5px'
  },
  bodyLargeBook: {
    fontFamily: 'MessinaSansBook',
    fontStyle: 'normal',
    fontWeight: '350',
    fontSize: '18px',
    lineHeight: '28px',
    letterSpacing: '0px'
  },
  bodyLargeBold: {
    fontFamily: 'MessinaSansBold',
    fontWeight: '700',
    fontSize: '18px',
    lineHeight: '28px',
    letterSpacing: '0px'
  },
  bodyLargeSemiBold: {
    fontFamily: 'MessinaSansSemiBold',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '28px',
    letterSpacing: '0px'
  },
  bodyMediumSemiBold: {
    fontFamily: 'MessinaSansSemiBold',
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0px'
  },
  bodySmallSemiBold: {
    fontFamily: 'MessinaSansSemiBold',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0px'
  },
  bodyMediumBook: {
    fontFamily: 'MessinaSansBook',
    fontWeight: '350',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0px'
  },
  bodyMediumBold: {
    fontFamily: 'MessinaSansBold',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0px'
  },
  bodySmallBook: {
    fontFamily: 'MessinaSansBook',
    fontWeight: '350',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0px'
  },
  bodySmallBold: {
    fontFamily: 'MessinaSansBold',
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0px'
  },
  captionLargeRegular: {
    fontFamily: 'MessinaSansRegular',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '0px'
  },
  captionMediumRegular: {
    fontFamily: 'MessinaSansRegular',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '0px'
  },
  buttonLarge: {
    fontFamily: 'MessinaSansBold',
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    Align: 'Center',
    VerticalAlign: 'Center'
  },
  buttonSmall: {
    fontFamily: 'MessinaSansBold',
    fontWeight: '700',
    fontSize: '12px',
    lineHeight: '20px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    Align: 'Center',
    VerticalAlign: 'Center'
  },
  overline: {
    fontFamily: 'MessinaSansMonoRegular',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '0.3px',
    textTransform: 'uppercase'
  },
  lowestLevel: {
    fontFamily: 'MessinaSansRegular',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0px'
  },
  tabRegular: {
    fontFamily: 'MessinaSansBook',
    fontWeight: '350',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '0px'
  },
  tabActive: {
    fontFamily: 'MessinaSansSemiBold',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '0px'
  }
};
export var MOTTO_COLOR = {
  primary: {
    '300': '#E5E9EE',
    '500': '#002855',
    '700': '#001C3C'
  },
  secondary: {
    '300': '#C0F4EF',
    '500': '#2EDBC9',
    '700': '#00A997'
  },
  tertiary: {
    '300': '#EBF1FF',
    '500': '#C2D4FF',
    '700': '#2969FF'
  },
  neutrals: {
    white: '#FFFFFF',
    '100': '#F2F3F4',
    '300': '#D6D9DA',
    '700': '#A7ADB0',
    '800': '#696E72',
    '900': '#434A4F'
  },
  text: {
    light: '#FFFFFF',
    disabled: '#A7ADB0',
    tertiary: '#696E72',
    secondary: '#434A4F',
    primary: '#002855',
    link: '#004BB9'
  },
  accent01: {
    '300': '#BEF1FF',
    '500': '#C2D4FF',
    '700': '#2969FF'
  },
  success: {
    '300': '#E0F5E5',
    '500': '#A4E2B4',
    '700': '#027D5E'
  },
  error: {
    '300': '#FEEAEA',
    '500': '#F1BFBF',
    '700': '#CF2A2A'
  },
  warning: {
    '300': '#FFF8D1',
    '500': '#FFEC9F',
    '700': '#FFD96A'
  },
  info: {
    '300': '#E5F2FF',
    '500': '#B9DEFA',
    '700': '#004BB9'
  },
  background: {
    white: '#FFFFFF',
    neutral: '#F2F3F4',
    light: '#E5F2FF',
    dark: '#002855',
    transparent: 'transparent'
  }
};
export var MOTTO_FONTS = {
  hero: {
    fontFamily: 'MessinaSansLight',
    fontStyle: 'normal',
    fontWeight: '100',
    fontSize: '60px',
    lineHeight: '68px',
    letterSpacing: '-1.5px'
  },
  h1: {
    fontFamily: 'MessinaSansLight',
    fontStyle: 'normal',
    fontWeight: '100',
    fontSize: '48px',
    lineHeight: '60px',
    letterSpacing: '0px'
  },
  h2: {
    fontFamily: 'MessinaSansLight',
    fontStyle: 'normal',
    fontWeight: '100',
    fontSize: '34px',
    lineHeight: '44px',
    letterSpacing: '-1px'
  },
  h3: {
    fontFamily: 'MessinaSansLight',
    fontStyle: 'normal',
    fontWeight: '100',
    fontSize: '24px',
    lineHeight: '36px',
    letterSpacing: '-1px'
  },
  bodyLargeBook: {
    fontFamily: 'MessinaSansBook',
    fontStyle: 'normal',
    fontWeight: '300',
    fontSize: '18px',
    lineHeight: '28px',
    letterSpacing: '0px'
  },
  bodyLargeBold: {
    fontFamily: 'MessinaSansBold',
    fontWeight: '700',
    fontSize: '18px',
    lineHeight: '28px',
    letterSpacing: '0px'
  },
  bodyMediumBook: {
    fontFamily: 'MessinaSansBook',
    fontWeight: '300',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0px'
  },
  bodyMediumBold: {
    fontFamily: 'MessinaSansBold',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0px'
  },
  bodySmallBook: {
    fontFamily: 'MessinaSansBook',
    fontWeight: '300',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0px'
  },
  bodySmallBold: {
    fontFamily: 'MessinaSansBold',
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0px'
  },
  captionLargeRegular: {
    fontFamily: 'MessinaSansRegular',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '0px'
  },
  captionMediumRegular: {
    fontFamily: 'MessinaSansRegular',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '0px'
  },
  buttonLarge: {
    fontFamily: 'MessinaSansBold',
    fontWeight: '700',
    fontSize: '18px',
    lineHeight: '20px',
    letterSpacing: '0px',
    Align: 'Center',
    VerticalAlign: 'Center'
  },
  buttonSmall: {
    fontFamily: 'MessinaSansBold',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '0px',
    Align: 'Center',
    VerticalAlign: 'Center'
  },
  overline: {
    fontFamily: 'MessinaSansMonoRegular',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '0px',
    textTransform: 'uppercase'
  },
  lowestLevel: {
    fontFamily: 'MessinaSansRegular',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0px'
  }
};
/*100: extraLight
300: light
400: mainLight
500: main
600: mainDark
700: dark
900: extraDark */

export var MOTTO_V2_COLOR = {
  primary: {
    '300': '#E9F1FB',
    '400': '#294466',
    '500': '#0B2341',
    '700': '#040C16'
  },
  secondary: {
    '100': '#F7FFFF',
    '300': '#DBF0F0',
    '500': '#ADDCDD',
    '600': '#5CB9BB',
    '700': '#22A3A6',
    '900': '#008081'
  },
  neutrals: {
    white: '#FFFFFF',
    '100': '#F0F2F2',
    '300': '#C9CDCD',
    '500': '#C9CDCD',
    '700': '#979A9A',
    '800': '#656767',
    '900': '#434545'
  },
  text: {
    white: '#FFFFFF',
    primary: '#040C16',
    secondary: '#454B52',
    link: '#22A3A6',
    disabledOnDark: '#2C3034',
    disabledOnWhite: 'rgba(10, 17, 26, 0.59)',
    disabled: '#5C6C7F'
  },
  accent01: {
    '100': '#FFFDFA',
    '300': '#FEEACD',
    '500': '#FCD192',
    '700': '#F9AC39',
    '900': '#D28006'
  },
  accent02: {
    '100': '#FFF7F9',
    '300': '#F6D5DE',
    '500': '#ED99B1',
    '600': '#E17090',
    '700': '#C33D63',
    '900': '#A93153'
  },
  error: {
    '300': '#FEEAEA',
    '500': '#F1BFBF',
    '700': '#CF2A2A'
  },
  info: {
    '300': '#F2FBFF',
    '500': '#C2E5F2',
    '700': '#2180A5'
  },
  gradientBackground: {
    yellowGrd: 'linear-gradient(180deg, #FCDE97 0%, #FACD64 100%)',
    pinkGrd: 'linear-gradient(180deg, #F291AD 0%, #D96297 100%)',
    tealGrd: 'linear-gradient(180deg, #77D7D9 0%, #4B9DA6 100%)',
    darkBlueGrd: 'linear-gradient(180deg, #0D294D 0%, #091B33 100%)'
  },
  solidBackground: {
    white: '#FFFFFF',
    neutral: '#F0F2F2',
    yellow: '#FCD192',
    pink: '#E686A1',
    teal: '#5CB9BB',
    darkBlue: '#0B2341'
  }
};
export var MOTTO_V2_FONTS = {
  heroLarge: {
    fontFamily: 'QanelasSoft',
    fontStyle: 'normal',
    fontWeight: '800',
    fontSize: '180px',
    lineHeight: '144px',
    letterSpacing: '-0.01em'
  },
  heroMedium: {
    fontFamily: 'QanelasSoft',
    fontStyle: 'normal',
    fontWeight: '800',
    fontSize: '110px',
    lineHeight: '99px',
    letterSpacing: '-0.01em'
  },
  h1: {
    fontFamily: 'QanelasSoft',
    fontStyle: 'normal',
    fontWeight: '800',
    fontSize: '70px',
    lineHeight: '70px',
    letterSpacing: '-0.01em'
  },
  h2: {
    fontFamily: 'QanelasSoft',
    fontStyle: 'normal',
    fontWeight: '800',
    fontSize: '50px',
    lineHeight: '50px',
    letterSpacing: '-0.01em'
  },
  h3: {
    fontFamily: 'QanelasSoft',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '30px',
    lineHeight: '36px',
    letterSpacing: '0.01em'
  },
  h4: {
    fontFamily: 'QanelasSoft',
    fontStyle: 'normal',
    fontWeight: '800',
    fontSize: '20px',
    lineHeight: '24px',
    letterSpacing: '0.01em'
  },
  breadcrumb: {
    fontFamily: 'QanelasSoft',
    fontStyle: 'normal',
    fontWeight: '800',
    fontSize: '14px',
    lineHeight: '16.8px',
    letterSpacing: '0.1em',
    textTransform: 'uppercase'
  },
  overline: {
    fontFamily: 'EBGaramondItalic',
    fontStyle: 'italic',
    fontWeight: '400',
    fontSize: '25px',
    lineHeight: '37.5px',
    letterSpacing: '-0.01em',
    textTransform: 'capitalize'
  },
  largeOverline: {
    fontFamily: 'EBGaramondItalic',
    fontStyle: 'italic',
    fontWeight: '400',
    fontSize: '40px',
    lineHeight: '60px',
    letterSpacing: '-0.01em',
    textTransform: 'capitalize'
  },
  largeEyebrow: {
    fontFamily: 'EBGaramondItalic',
    fontStyle: 'italic',
    fontWeight: '400',
    fontSize: '40px',
    lineHeight: '60px',
    letterSpacing: '-0.01em'
  },
  bodyLargeBook: {
    fontFamily: 'EBGaramond',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '25px',
    lineHeight: '37.5px',
    letterSpacing: '-0.01em'
  },
  bodyLargeBold: {
    fontFamily: 'EBGaramond',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '25px',
    lineHeight: '37.5px',
    letterSpacing: '-0.01em'
  },
  bodyMediumBook: {
    fontFamily: 'EBGaramond',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '32px',
    letterSpacing: '-0.01em'
  },
  bodyMediumBold: {
    fontFamily: 'EBGaramond',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '32px',
    letterSpacing: '-0.01em'
  },
  bodySmallBook: {
    fontFamily: 'EBGaramond',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '15px',
    lineHeight: '27px',
    letterSpacing: '-0.01em'
  },
  bodySmallBold: {
    fontFamily: 'EBGaramond',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '15px',
    lineHeight: '27px',
    letterSpacing: '-0.01em'
  },
  captionLargeRegular: {
    fontFamily: 'EBGaramond',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '21.6px',
    letterSpacing: '-0.01em'
  },
  captionMediumRegular: {
    fontFamily: 'EBGaramond',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '21.6px',
    letterSpacing: '-0.01em'
  },
  buttonLarge: {
    fontFamily: 'QanelasSoft',
    fontStyle: 'normal',
    fontWeight: '800',
    fontSize: '20px',
    lineHeight: '24px',
    letterSpacing: '0.01em',
    Align: 'Center',
    VerticalAlign: 'Center'
  },
  buttonSmall: {
    fontFamily: 'QanelasSoft',
    fontWeight: '800',
    fontSize: '14px',
    lineHeight: '16.8px',
    letterSpacing: '0.1em',
    Align: 'Center',
    VerticalAlign: 'Center'
  },
  navigationLink: {
    fontFamily: 'QanelasSoftRegular',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '19.2px',
    letterSpacing: '-0.01em'
  }
};
export var WELLNOW_COLOR = {
  primary: {
    '300': '#EEF4FF',
    '500': '#003592',
    '700': '#002A75'
  },
  secondary: {
    '300': '#E4EFFF',
    '500': '#0061EF',
    '700': '#004EBF'
  },
  tertiary: {
    '300': '#FFF5E5',
    '500': '#FFBE4C',
    '700': '#FFA200'
  },
  neutrals: {
    white: '#FFFFFF',
    '100': '#F2F3F4',
    '300': '#D6D9DA',
    '700': '#A7ADB0',
    '800': '#696E72',
    '900': '#434A4F'
  },
  text: {
    light: '#FFFFFF',
    disabled: '#A7ADB0',
    tertiary: '#696E72',
    secondary: '#202225',
    primary: '#003592',
    interactive: '#0061EF'
  },
  accent01: {
    '300': '#F8F8FF',
    '500': '#746FB1',
    '700': '#514E7C'
  },
  accent02: {
    '300': '#F4D3EE',
    '500': '#C821AC',
    '700': '#A01A8A'
  },
  success: {
    '300': '#E0F5E5',
    '500': '#A4E2B4',
    '700': '#027D5E'
  },
  error: {
    '300': '#FEEAEA',
    '500': '#F1BFBF',
    '700': '#CF2A2A'
  },
  warning: {
    '300': '#FFF8D1',
    '500': '#FFEC9F',
    '700': '#FFD96A'
  },
  info: {
    '300': '#E5F2FF',
    '500': '#B9DEFA',
    '700': '#004BB9'
  },
  background: {
    white: '#FFFFFF',
    neutral: '#F2F3F4',
    light: '#746FB1',
    dark: '#003592',
    transparent: 'transparent'
  }
};
export var WELLNOW_FONTS = {
  heroLarge: {
    fontFamily: 'Avenir Book',
    fontWeight: '300',
    fontSize: '64px',
    lineHeight: '80px',
    letterSpacing: '0px'
  },
  heroMedium: {
    fontFamily: 'Avenir Book',
    fontWeight: '300',
    fontSize: '53px',
    lineHeight: '68px',
    letterSpacing: '0px',
    '@media (max-width:600px)': {
      fontSize: '41px',
      lineHeight: '52px'
    }
  },
  h1: {
    fontFamily: 'Avenir Heavy',
    fontWeight: '700',
    fontSize: '38px',
    lineHeight: '52px',
    letterSpacing: '0px',
    '@media (max-width:600px)': {
      fontSize: '29px',
      lineHeight: '36px'
    }
  },
  h2: {
    fontFamily: 'Avenir Heavy',
    fontWeight: '700',
    fontSize: '31px',
    lineHeight: '44px',
    letterSpacing: '0px',
    '@media (max-width:600px)': {
      fontSize: '25px',
      lineHeight: '32px'
    }
  },
  h3: {
    fontFamily: 'Avenir Heavy',
    fontWeight: '700',
    fontSize: '26px',
    lineHeight: '36px',
    letterSpacing: '0px',
    '@media (max-width:600px)': {
      fontSize: '22px',
      lineHeight: '28px'
    }
  },
  h4: {
    fontFamily: 'Avenir Medium',
    fontWeight: '500',
    fontSize: '22px',
    lineHeight: '32px',
    letterSpacing: '0px',
    '@media (max-width:600px)': {
      fontSize: '20px',
      lineHeight: '28px'
    }
  },
  bodyLargeBook: {
    fontFamily: 'Avenir Book',
    fontWeight: '300',
    fontSize: '18px',
    lineHeight: '28px',
    letterSpacing: '0px'
  },
  bodyLargeSemiBold: {
    fontFamily: 'Avenir Medium',
    fontWeight: '500',
    fontSize: '18px',
    lineHeight: '28px',
    letterSpacing: '0px'
  },
  bodyLargeBold: {
    fontFamily: 'Avenir Heavy',
    fontWeight: '700',
    fontSize: '18px',
    lineHeight: '28px',
    letterSpacing: '0px'
  },
  bodyMediumBook: {
    fontFamily: 'Avenir Book',
    fontWeight: '300',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0px'
  },
  bodyMediumSemiBold: {
    fontFamily: 'Avenir Medium',
    fontWeight: '500',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0px'
  },
  bodyMediumBold: {
    fontFamily: 'Avenir Heavy',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0px'
  },
  bodySmallBook: {
    fontFamily: 'Avenir Book',
    fontWeight: '300',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0px'
  },
  bodySmallSemiBold: {
    fontFamily: 'Avenir Medium',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0px'
  },
  bodySmallBold: {
    fontFamily: 'Avenir Heavy',
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0px'
  },
  button: {
    fontFamily: 'Avenir Medium',
    fontWeight: '500',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '0px',
    textTransform: 'none'
  },
  lowestLevel: {
    fontFamily: 'Avenir Book',
    fontWeight: '300',
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0px'
  }
};
export var ICON_SIZES = {
  xs: 14.53,
  sm: 18.16,
  md: 21.8,
  lg: 29.06
};